function initHarsikaAccountHistory() {
  $(".block-text__btn-link").click(function () {
    if (!$(this).data("text")) {
      $(this).data("text", $(this).text());
    }

    $(this)
      .closest("tr")
      .next()
      .find(".account-history__products-wrapper")
      .slideToggle();
    $(this).text(
      $(this).text() == $(this).data("text") ? "Скрыть" : $(this).data("text")
    );
  });
}
